import React, { useEffect } from "react";
import { Card, Table, Layout, Space, Button } from "antd";
import { observer } from "mobx-react";
import { useHistory, useLocation } from "react-router-dom";
import { fmtDateTime } from "../../../common/Utils";
import { channelInvitationsStore } from "../../../store/invitation/ChannelInvitationsStore";
import { Toolbar } from "../../../components/Toolbar";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";

export const Activities = observer(() => {
  const location = useLocation();
  const history = useHistory();

  const store = channelInvitationsStore;

  // const onTab = (pending) => {
  //   console.log(pending);
  //   const query = new URLSearchParams({ pending });
  //   history.push({
  //     search: query.toString(),
  //   });
  // };

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };
  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Name",
      dataIndex: "name",
    },

    {
      title: "State",
      dataIndex: "state",
    },
    {
      title: "Create Date",
      dataIndex: "createDate",
      render: fmtDateTime,
    },

    {
      title: "Notes",
      dataIndex: "notes",
    },
    {
      title: "",
      render: (_, r) => (
        <Space>
          <EditOutlined onClick={() => store.edit.edit(r)} />
        </Space>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar
        actions={
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            // onClick={() => store.edit.edit({ state: "Active" })}
          >
            New Activity
          </Button>
        }
      ></Toolbar>

      {/* <Card bodyStyle={{ padding: "16px 8px" }} style={{ margin: "16px 0" }}>
        <FilterBar store={store}>
          <Form.Item label="Keyword">
            <Input.Search value={store.filter.keyword} onChange={(e) => (store.filter.keyword = e.target.value)} />
          </Form.Item>
        </FilterBar>
      </Card> */}

      <Card size="small" style={{ marginTop: 16 }}>
        <Table
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          rowKey="id"
          columns={columns}
          dataSource={[]}
        />
      </Card>
      {/* {store.edit.visible && <ChannelInvitationDlg />} */}
    </Layout.Content>
  );
});
